import {Component, Prop, Vue} from "vue-property-decorator";
import iconClose from "~/assets/inline-svg/icon_close.svg?inline";
import {getDefaultSupportEmail} from "~/modules/quotas/service";

@Component
class ModalQuotas extends Vue {

  @Prop({required: true, type: String}) title: string;
  @Prop({required: true, type: String}) message: string;

  protected supportEmail: string = null;

  async created() {
    this.supportEmail = await getDefaultSupportEmail();
  }

  render() {
    return (
      <div class="modal is-active alert-dialog">
        <div class="modal-background"/>
        <div class="modal-card">
          <div class="modal-card-head">
            <h2 class="modal-card-title has-text-centered">{this.title}</h2>
            <div class="icon icon-close" domPropsInnerHTML={iconClose} onClick={() => this.$emit("close")}/>
          </div>
          <section class="modal-card-body">
            <p>{this.message} {this.supportEmail && <a class="quota-support-cta" href={`mailto:${this.supportEmail}`}>ou contacter le support</a>}</p>
          </section>
        </div>
      </div>
    )
  }
}

export {ModalQuotas};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-a052bb24/modal-quotas.tsx" });